import React from "react";
import { twMerge } from "tailwind-merge";

const { fighterEnties, fighterEntryDisplayMapping } = require("../constants");

function FighterRecordsTable({ records, handleRecordChange }) {
    return (
        <div className="flex flex-center w-full gap-2 h-full ![&>div]:overflow-x-hidden">
            {fighterEnties.map((entry, index) => {
                return <div key={index} className="flex flex-col md:flex-row w-full items-center justify-start gap-2">
                    <p className='w-full md:min-w-24 flex-2'>{fighterEntryDisplayMapping[entry]}:</p>
                    <div className="flex flex-row gap-4 w-full md:w-auto">
                        <input
                            className={twMerge(
                                'flex-1 md:w-12 md:flex-none min-w-24 input', 
                                !!handleRecordChange 
                                ? "input-bordered" 
                                : "text-center pointer-events-none"
                            )}
                            min={0}
                            placeholder='WIN'
                            type="number"
                            defaultValue={records?.[entry]?.win ?? 0}
                            name="win"
                            id="win"
                            onChange={e => {
                                handleRecordChange(entry, e.target.name, e.target.value);
                            }}
                            pattern="[0-9]*"
                            inputMode="numeric"
                        />
                        <input
                            className={twMerge(
                                'flex-1 md:w-12 md:flex-none min-w-24 input', 
                                !!handleRecordChange 
                                ? "input-bordered" 
                                : "text-center pointer-events-none"
                            )}
                            min={0}
                            placeholder='LOSS'
                            type="number"
                            defaultValue={records?.[entry]?.loss ?? 0}
                            name="loss"
                            id="loss"
                            onChange={e => {
                                handleRecordChange(entry, e.target.name, e.target.value);
                            }}
                            pattern="[0-9]*"
                            inputMode="numeric"
                        />
                        <input
                            className={twMerge(
                                'flex-1 md:w-12 md:flex-none min-w-24 input', 
                                !!handleRecordChange 
                                ? "input-bordered" 
                                : "text-center pointer-events-none"
                            )}
                            min={0}
                            placeholder='DRAW'
                            type="number"
                            defaultValue={records?.[entry]?.draw ?? 0}
                            name="draw"
                            id="draw"
                            onChange={e => {
                                handleRecordChange(entry, e.target.name, e.target.value);
                            }}
                            pattern="[0-9]*"
                            inputMode="numeric"
                        />
                    </div>
                </div>;
            })}
            <div className="divider m-0" />
            <div className="flex flex-col md:flex-row w-full justify-between items-center opacity-70 gap-2">
                <p className='w-full flex-2 md:min-w-24'>Totals</p>
                <div className="flex flex-row gap-4 w-full md:w-auto">
                    <p className={twMerge('w-full md:w-24 pl-4', !!handleRecordChange ? "text-start" : "text-center")}>
                        {fighterEnties.map(entry => {
                            return records?.[entry]?.win ?? 0;
                        }).reduce((a, b) => {
                            return a + parseInt(b || 0) || 0;
                        }, 0)}
                    </p>
                    <p className={twMerge('w-full md:w-24 pl-4', !!handleRecordChange ? "text-start" : "text-center")}>
                        {fighterEnties.map(entry => {
                            return records?.[entry]?.loss ?? 0;
                        }).reduce((a, b) => {
                            return a + parseInt(b || 0) || 0;
                        }, 0)}
                    </p>
                    <p className={twMerge('w-full md:w-24 pl-4', !!handleRecordChange ? "text-start" : "text-center")}>
                        {fighterEnties.map(entry => {
                            return records?.[entry]?.draw ?? 0;
                        }).reduce((a, b) => {
                            return a + parseInt(b || 0) || 0;
                        }, 0)}
                    </p>
                </div>
            </div>
        </div>);
}

export default FighterRecordsTable;